(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .controller('logOutCtrl', logOutCtrl);

  logOutCtrl.$inject = ['Auth', '$location', '$timeout'];

  function logOutCtrl (Auth, $location, $timeout) {
    Auth.logout();
    const redirect = $timeout(function () {
      $location.path('/');
      $timeout.cancel(redirect);
    });
  }
})();
